import "core-js/modules/es.array.concat.js";
/**
 * getPictureUrl
 * Returns the URL for a picture with the given image file ID and dimensions.
 * @param obj - Object with the following properties:
 * @param obj.id - ID of the image file
 * @param obj.dimensions - Image URL suffix used to load an image at a specific size
 * @returns {string} - URL of the picture or empty string if no image file ID is provided
 */
export function getPictureUrl(_ref) {
  var id = _ref.id,
    dimensions = _ref.dimensions;
  if (!id) {
    return '';
  }
  var dimentionsUrlSuffix = dimensions ? "/".concat(dimensions) : '';
  return "/api/picture/".concat(id).concat(dimentionsUrlSuffix);
}
export var TOPIC_CARD = 'w_208,h_130';
export var PLAYLIST_HERO = 'w_1364,h_341';
export var BILLBOARD = 'w_926,h_380';
export var HORIZONTAL_CARD = 'w_260,h_175';
export var VERTICAL_CARD = 'w_666,h_274';
export var TINY_CARD = 'w_108,h_72';
export var INSPECTOR = 'w_340,h_227';
export var AVATAR = 's_60';
export var DIMENSIONS = {
  PLAYLIST_HERO: PLAYLIST_HERO,
  BILLBOARD: BILLBOARD,
  HORIZONTAL_CARD: HORIZONTAL_CARD,
  VERTICAL_CARD: VERTICAL_CARD,
  TINY_CARD: TINY_CARD,
  INSPECTOR: INSPECTOR,
  AVATAR: AVATAR
};
export default getPictureUrl;